'use memo';

import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import { Translation as TranslationBase, type TranslationProps } from 'react-i18next';
import type { AppTFunction } from './i18next-types';

/**
 * react-i18next の Translation をラップ。
 * children に渡す t は移行期の {@link AppTFunction}（string key + Selector API）。
 */
type TranslationRenderProps = {
  children: (t: AppTFunction) => ReactNode;
  ns?: string | readonly string[];
  keyPrefix?: string;
  i18n?: i18n;
  useSuspense?: boolean;
  nsMode?: 'fallback' | 'default';
};
export function Translation({
  children,
  ...props
}: TranslationRenderProps) {
  return <TranslationBase {...props as TranslationProps}>
      {t => children(t as AppTFunction)}
    </TranslationBase>;
}